import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'semantic-ui-react';
import Formsy from 'formsy-react';

export default class ListTitleInput extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    listId: PropTypes.string,
    placeholder: PropTypes.string,
    commitUpdate: PropTypes.func.isRequired,
    closeHandler: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title
    };
    this.onChange = this.onChange.bind(this);
    this.moveCaretAtEnd = this.moveCaretAtEnd.bind(this);
  }

  componentWillUnmount() {
    this.props.commitUpdate({ id: this.props.listId, title: this.state.title });
  }

  onChange(e) {
    this.setState({ title: e.target.value });
  }

  moveCaretAtEnd() {
    // Hack to move cursor to end of input
    const title = this.state.title;
    this.setState({ title: '' }, () => this.setState({ title }));
  }

  render() {
    return (
      <Formsy.Form onBlur={this.props.closeHandler}>
        <h3>
          <Input
            value={this.state.title}
            placeholder={this.props.placeholder}
            rows={1}
            name='title'
            autoComplete='off'
            transparent
            autoFocus
            onFocus={this.moveCaretAtEnd}
            fluid
            onChange={this.onChange}
            style={{ fontWeight: 'bold', paddingTop: '1px' }}
          />
        </h3>
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Pipelines/ListTitleInput.js